//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RequestWorkTypeRequiredIcon from '../../Request/RequestWorkTypeRequiredIcon.vue'
import { formatConfiguredTime } from '../../../components/helpers.js'

export default {
  components: {
    RequestWorkTypeRequiredIcon
  },
  props: {
    records: {
      type: Array,
      required: true
    },
    keyPrefix: {
      type: [String, Number],
      default: ''
    },
    openResults: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      openedIndex: null
    }
  },
  methods: {
    formatReportName: function (reportName) {
      const idx = reportName.indexOf('№')
      const result = idx !== -1 ? reportName.slice(idx) : ''
      return 'отчёт ' + result
    },
    formatTime: function (val) {
      return formatConfiguredTime(val, { year: true, month: true, date: true, hour: true, min: true, sec: false })
    },
    onRecordClick (record, idx) {
      if (!this.openResults) {
        return
      }

      this.openedIndex = this.openedIndex === idx ? null : idx
    }
  }
}
